/**
 * apiErrorMessage — turn a failed API response into an honest user-facing message.
 *
 * Callers do `const data = await response.json().catch(() => ({}))` (so a non-JSON
 * body — e.g. a Render/Cloudflare 502/503 HTML page — no longer throws into the
 * generic "network error" catch), then, when `!response.ok`, call this with the
 * status + parsed body. It prefers the server's own `{ error }` / `{ errors }`, and
 * otherwise maps the status to a specific message instead of blaming the user's
 * connection: 429 = throttled, 5xx = server warming up / unavailable.
 *
 * @param {number} status         response.status
 * @param {object} data           parsed JSON body (or {} if it wasn't JSON)
 * @param {string} [fallback]     message when nothing more specific applies
 * @returns {string}
 */
export function apiErrorMessage(status, data, fallback = 'Request failed. Please try again.') {
    if (data && (data.errors || data.error)) {
        return Array.isArray(data.errors) ? data.errors.join('; ') : (data.error || fallback);
    }
    if (status === 429) {
        return 'You are submitting too quickly — wait a moment and try again.';
    }
    if (status >= 500) {
        return 'The server is starting up or temporarily unavailable — please retry in a few seconds.';
    }
    return fallback;
}

export default apiErrorMessage;
